// *******************************************************************************
// Form : Step Form
// *******************************************************************************
const stepFormElem = document.querySelector('.step-form');

if (stepFormElem) {
  const handleStepForm = (form, formAction) => {
    const formParent = form.closest('[data-step-form-parent]');
    const allFormSteps = formParent.querySelectorAll('.step-form__step');
    const allStepIndicator = formParent.querySelectorAll('.step-form__indicator-btn');
    const nextButton = formParent.querySelector('.step-form__next-step');
    const nextButtonInner = formParent.querySelector('.step-form__next-step .btn__text');
    const prevButton = formParent.querySelector('.step-form__prev-step');
    const submitButtonText = nextButton.getAttribute('data-submit-text');
    const formAlertError = formParent.querySelector('.step-form__alert-error');
    const nextButtonText = nextButton.querySelector('.btn__text').innerHTML;
    const allForms = [];
    const allStepData = [];
    const allStepRequiredData = [];
    const emailError = getEmailError(form);

    let currentStepIndex = 0;

    const toggleStep = (index, active) => {
      const step = allFormSteps[index];
      const stepIndicator = allStepIndicator[index];

      FormValidation.utils.classSet(step, {
        'is-active': active,
      });
      FormValidation.utils.classSet(stepIndicator, {
        'is-active': active,
      });
      FormValidation.utils.classSet(stepIndicator, {
        'is-completed': active,
      });
    };

    const markCompleted = (index) => {
      const stepIndicator = allStepIndicator[index];
      stepIndicator.classList.add('is-completed');
    };

    const moveNextStep = async () => {
      if (currentStepIndex < allForms.length) {
        const currentForm = allForms[currentStepIndex];
        const status = await currentForm.validate();

        if (status !== 'Valid') {
          return;
        }

        let nextIndex = currentStepIndex + 1;

        while (nextIndex < allFormSteps.length && allFormSteps[nextIndex].classList.contains('hide')) {
          nextIndex++;
        }

        if (nextIndex < allFormSteps.length) {
          toggleStep(currentStepIndex, false);
          currentStepIndex = nextIndex;
          toggleStep(currentStepIndex, true);
          prevButton?.classList.remove('hide');
        }

        if (currentStepIndex === allFormSteps.length - 1) {
          nextButtonInner.innerHTML = submitButtonText;
        }

        scrollTop(formParent);
      }
    };

    const moveBackStep = () => {
      if (currentStepIndex > 0) {
        allStepIndicator.forEach((indicator) => indicator.classList.remove('is-active'));

        toggleStep(currentStepIndex, false);
        currentStepIndex--;
        toggleStep(currentStepIndex, true);

        if (currentStepIndex === 0) {
          prevButton?.classList.add('hide');
        }

        nextButtonInner.innerHTML = nextButtonText;
        scrollTop(formParent);
      }
    };

    allFormSteps.forEach((step, index) => {
      const emailFields = step.querySelectorAll('input[type="email"]'); // Get all email fields

      const fieldValidators = {};
      emailFields.forEach((field) => {
        const fieldName = field.name;

        if (fieldName) {
          fieldValidators[fieldName] = {
            validators: {
              callback: {
                message: emailError,
                callback(input) {
                  return validateEmail(input.value);
                },
              },
            },
          };
        }
      });

      const fv = FormValidation.formValidation(step, {
        locale: 'sl_SI',
        localization: FormValidation.locales.sl_SI,
        fields: fieldValidators,
        plugins: {
          message: new FormValidation.plugins.Message({
            container: (field, element) =>
              element.closest('.mod-input,.checkbox,.radio-button,.dropdown,.mod-toggle,.upload-box'),
          }),
          declarative: new FormValidation.plugins.Declarative({
            html5Input: true,
          }),
          trigger: new FormValidation.plugins.Trigger({
            event: 'submit',
          }),
          excluded: new FormValidation.plugins.Excluded({
            excluded() {
              return false;
            },
          }),
          submitButton: new FormValidation.plugins.SubmitButton(),
        },
      })
        .on('core.element.validated', (e) => {
          if (e.element.hasAttribute('required')) {
            const value = fv.getElementValue(e.field, e.element);
            const container = FormValidation.utils.closest(
              e.element,
              '.mod-input,.checkbox,.radio-button,.dropdown,.mod-toggle,.upload-box',
            );
            FormValidation.utils.classSet(container, {
              'is-validation-failed': value === '' || !e.valid,
            });
          }
        })
        .on('core.form.valid', () => {
          grecaptcha.ready(async () => {
            formParent.classList.add('show-loader');

            try {
              const stepData = getFormValue(step, fv);
              allStepData.push(JSON.parse(stepData.inputs));
              allStepRequiredData.push(JSON.parse(stepData.requiredInputs));
              const formType = form.getAttribute('id');

              // if (index < allFormSteps.length - 1) {
              // stepFormGTMDataLayer(index, stepData.inputs, formType, 'form_step');
              // }

              if (index === allFormSteps.length - 1) {
                // stepFormGTMDataLayer(index, stepData.inputs, formType, 'form_submit');

                const inputs = Object.assign({}, ...allStepData);
                const requiredInputs = Object.assign({}, ...allStepRequiredData);

                // const files = {};
                // Array.from(filesToUpload).forEach((file, index) => {
                //   files[`files_${index + 1}`] = file.file;
                // });

                await onFormSubmit({
                  formData: {
                    // ...files,
                    inputs: JSON.stringify(inputs),
                    requiredInputs: JSON.stringify(requiredInputs),
                    lang: localData.lang,
                    id: localData.id,
                    formType,
                    workshopTitle: form.querySelector('[data-workshop]')?.value || '',
                  },
                  recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
                  recaptchaAction: formAction,
                });
              }

              formParent.classList.remove('show-loader');

              if (index === allFormSteps.length - 1) {
                formParent.classList.add('show-thankyou');
                if (formParent.closest('.form-modal')) {
                  const formModalEle = formParent.closest('.form-modal');
                  formModalEle.classList.add('show-thankyou');
                }
              } else {
                toggleStep(index, false);
                if (index + 1 < allFormSteps.length) {
                  toggleStep(index + 1, true);
                }
              }
              markCompleted(index);
            } catch (error) {
              console.error(error);

              formParent.classList.remove('show-loader');
              formParent.classList.add('show-error');
              formAlertError.classList.remove('hide');

              const message =
                error?.response?.data?.data?.msg ??
                error?.response?.data?.message ??
                error?.message ??
                'Something went wrong. Please try again.';

              formAlertError.textContent = message;
            }
          });
        });

      allForms.push(fv);

      attachEvent('[data-modal-trigger]', 'click', () => {
        fv.resetForm();
        moveBackStep();
      });
    });

    nextButton.addEventListener('click', moveNextStep);
    prevButton?.addEventListener('click', moveBackStep);
  };

  document.addEventListener('DOMContentLoaded', () => {
    ['programs_form'].forEach((id) => {
      const form = document.querySelector(`#${id}`);
      if (form !== null) {
        const formAction = form.querySelector('[data-action]').value;
        handleStepForm(form, formAction);
      }
    });
  });

  ['programs_form'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      window.addEventListener('pageshow', (event) => {
        const navigationEntries = performance.getEntriesByType('navigation');
        if (
          event.persisted ||
          (window.performance && navigationEntries.length > 0 && navigationEntries[0].type === 'back_forward')
        ) {
          window.location.reload();
        }
      });
    }
  });
}

const toggleFields = document.querySelectorAll('[data-toggle-field]');
if (toggleFields.length > 0) {
  const update = () => {
    document.querySelectorAll('[data-toggle-item]').forEach((item) => {
      const field = item.querySelector('[data-field]');

      if (!field) {
        return;
      }

      const values = field.dataset.field.split(',').map((v) => v.trim());

      const visible = values.some((value) => {
        const toggle = document.querySelector(`[data-toggle-field="${value}"]`);

        return toggle?.checked;
      });

      item.classList.toggle('hide', !visible);
    });

    document.querySelectorAll('[data-toggle-parent]').forEach((parent) => {
      const items = parent.querySelectorAll('[data-toggle-item]');

      // Step 1 hits this and is ignored
      if (!items.length) {
        return;
      }

      const hasVisibleItems = [...items].some((item) => !item.classList.contains('hide'));

      parent.classList.toggle('hide', !hasVisibleItems);
    });
  };

  toggleFields.forEach((input) => input.addEventListener('change', update));

  update();
}

// Toggle tags on check/uncheck of step 1
const stepOneCheckBoxes = document.querySelectorAll('.step-form__step-1 .checkbox input');
const stepTwoTags = document.querySelectorAll('.step-form__step-2 .checkbox__tags');
if (stepOneCheckBoxes.length > 0) {
  const hideTagCheckboxes = document.querySelectorAll('.step-form__step-1 .checkbox input[data-hide-tag]');

  const toggleTags = () => {
    const shouldHide = [...hideTagCheckboxes].some((checkbox) => checkbox.checked);

    stepTwoTags.forEach((tags) => {
      tags.classList.toggle('hide', shouldHide);
    });
  };

  stepOneCheckBoxes.forEach((checkbox) => {
    checkbox.addEventListener('change', toggleTags);
  });

  toggleTags();
}
